import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "user-mgr-page" }
const _hoisted_2 = { class: "user-mgr-layout" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { class: "user-mgr-header" }
const _hoisted_5 = { class: "user-mgr-list" }
const _hoisted_6 = { class: "user-mgr-pagination" }

import { ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import SystemSideMenu from '@/components/SystemSideMenu.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserManager',
  setup(__props) {

const selectedKeys = ref(['user-mgr'])
const openKeys = ref(['system'])
const router = useRouter()
const route = useRoute()

// 页面加载和路由变化时自动高亮
watch(
  () => route.path,
  (path) => {
    if (path === '/system/user-mgr') selectedKeys.value = ['user-mgr']
    else if (path === '/system/feedback') selectedKeys.value = ['feedback']
    else if (path === '/system/sync') selectedKeys.value = ['sync']
    else selectedKeys.value = []
    openKeys.value = ['system']
  },
  { immediate: true }
)

function onMenuSelect({ key }: { key: string }) {
  selectedKeys.value = [key]
  if (key === 'feedback') router.push('/system/systemConfig/feedback')
  else if (key === 'user-mgr') router.push('/system/systemConfig/user-mgr')
  else if (key === 'sync') router.push('/system/systemConfig/sync')
  // 其它菜单可按需跳转
}

const columns = [
  { title: '用户ID', dataIndex: 'id', key: 'id' },
  { title: '用户名', dataIndex: 'username', key: 'username' },
  { title: '昵称', dataIndex: 'nickname', key: 'nickname' },
  { title: '标签', dataIndex: 'tag', key: 'tag' },
  { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt' },
  { title: '联系电话', dataIndex: 'phone', key: 'phone' },
  { title: '邮箱', dataIndex: 'email', key: 'email' },
  { title: '设备数', dataIndex: 'deviceCount', key: 'deviceCount' },
  { title: '状态', dataIndex: 'status', key: 'status' },
  { title: '操作', key: 'action' }
]
const dataSource = [
  {
    id: '1740358057038188544',
    username: 'administrator',
    nickname: '超级管理员',
    tag: '-',
    createdAt: '2023-05-02 11:33',
    phone: '-',
    email: '-',
    deviceCount: 0,
    status: '正常'
  },{
    id: '5558265232688482957',
    username: 'ys.yes',
    nickname: '杨胜',
    tag: '-',
    createdAt: '2023-05-08 11:33',
    phone: '-',
    email: '-',
    deviceCount: 0,
    status: '正常'
  },{
    id: '5558265232688482957',
    username: 'sarah.cheng',
    nickname: '陈心佩',
    tag: '-',
    createdAt: '2023-05-08 11:35',
    phone: '-',
    email: '-',
    deviceCount: 0,
    status: '正常'
  },{
    id: '5558265232688482957',
    username: 'xiaoxi.yuan',
    nickname: '袁小希',
    tag: '-',
    createdAt: '2023-05-08 11:40',
    phone: '-',
    email: '-',
    deviceCount: 0,
    status: '正常'
  },{
    id: '5558265232688482957',
    username: 'chang.wu',
    nickname: '吴畅',
    tag: '-',
    createdAt: '2023-05-08 11:45',
    phone: '-',
    email: '-',
    deviceCount: 0,
    status: '正常'
  },{
    id: '5558265232688482957',
    username: 'jun.you',
    nickname: '游钧',
    tag: '-',
    createdAt: '2023-05-08 11:55',
    phone: '-',
    email: '-',
    deviceCount: 0,
    status: '正常'
  },{
    id: '5558265232688482957',
    username: 'jun.liu',
    nickname: '刘俊',
    tag: '-',
    createdAt: '2023-05-08 12:05',
    phone: '-',
    email: '-',
    deviceCount: 0,
    status: '正常'
  },{
    id: '5558265232688482957',
    username: 'hongsheng.jia',
    nickname: '贾红胜',
    tag: '-',
    createdAt: '2023-05-08 12:10',
    phone: '-',
    email: '-',
    deviceCount: 0,
    status: '正常'
  }
]

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_input, {
                placeholder: "请输入关键词",
                style: {"width":"220px","margin-right":"16px"}
              }),
              _createVNode(_component_a_button, { type: "primary" }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("+ 新增用户")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "user-mgr-group" }, "工业平台（1人）", -1)),
              _createVNode(_component_a_table, {
                columns: columns,
                "data-source": dataSource,
                pagination: false,
                size: "middle"
              }, {
                bodyCell: _withCtx(({ column, record }) => [
                  (column.key === 'action')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[1] || (_cache[1] = _createElementVNode("a", { style: {"color":"#1677ff","margin-right":"8px"} }, "编辑", -1)),
                        _cache[2] || (_cache[2] = _createElementVNode("a", { style: {"color":"#1677ff","margin-right":"8px"} }, "详情", -1)),
                        _cache[3] || (_cache[3] = _createElementVNode("a", { style: {"color":"#ff4d4f"} }, "删除", -1))
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_6, [
                _cache[6] || (_cache[6] = _createElementVNode("span", null, "共1条", -1)),
                _createVNode(_component_a_pagination, {
                  total: 1,
                  pageSize: 10,
                  current: 1,
                  style: {"margin":"0 16px"}
                }),
                _createVNode(_component_a_select, {
                  value: 10,
                  style: {"width":"90px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 10 }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode("10条/页")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 20 }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("20条/页")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})